import React from 'react';
import styled from 'styled-components';
import { xpCss, webCss, XP, WEB } from 'lib/xp';

import pfp from 'assets/pfp.png';
import { fmtAmt } from 'data/epochs';
import { useLedger } from 'data/ledger';
import { LIVE as CASINO_LIVE, PRACTICE as CASINO_PRACTICE } from 'lib/casino';

// The Internet Coin homepage, rendered inside Internet Explorer.
// Y2K portal register on purpose: tables, badges, marquee, hit counter.

const LINKS = {
  x: null, // set at launch
  dexscreener: null, // set at launch
  buy: null, // set at launch
};

function Badge({ children }) {
  return <span className="ic-badge">{children}</span>;
}
function openApp(name) {
  window.dispatchEvent(new CustomEvent('ic:open', { detail: name }));
}
// Same ic:open event, object form — WinXP passes `props` straight into the app as injectProps.
function openPicturesCore() {
  window.dispatchEvent(new CustomEvent('ic:open', { detail: { app: 'My Pictures', props: { group: 'core' } } }));
}

// The Internet Core strip: eight pool thumbnails, the same eight all day, a different eight
// tomorrow. mulberry32 seeded on the day number — no state, no storage, same picks for everyone.
function dailyRandom(seed) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
function pickDaily(items, n) {
  const rand = dailyRandom(Math.floor(Date.now() / 864e5) + 1);
  const pool = items.slice();
  const out = [];
  while (out.length < n && pool.length > 0) out.push(pool.splice(Math.floor(rand() * pool.length), 1)[0]);
  return out;
}

function InternetCore() {
  const [core, setCore] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    fetch('/gallery/manifest.json')
      .then(r => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(m => {
        if (!alive) return;
        const items = m && Array.isArray(m.items) ? m.items : [];
        setCore(items.filter(i => i && i.group === 'core' && typeof i.thumb === 'string'));
      })
      .catch(() => {
        /* no manifest, no strip — the rest of the page is unaffected */
      });
    return () => {
      alive = false;
    };
  }, []);
  const strip = React.useMemo(() => (core ? pickDaily(core, 8) : []), [core]);
  if (strip.length === 0) return null;
  return (
    <tr>
      <td className="ic-section ic-core">
        <h2>▸ INTERNET CORE <span className="ic-new-tag">{core.length} pieces of the old internet</span></h2>
        <div className="ic-core-strip">
          {strip.map(it => (
            <img key={it.id} className="ic-core-thumb" src={it.thumb} alt={it.name} title={it.name} loading="lazy" onClick={openPicturesCore} />
          ))}
        </div>
        <p className="ic-core-open">
          <span onClick={openPicturesCore}>open My Pictures →</span>
        </p>
      </td>
    </tr>
  );
}

// Glitch-decode headline — scrambles then resolves on mount, re-triggers on hover.
// Same motif as the boot's decode stage. Self-contained, no external deps.
const GLYPHS = '!<>-_/[]{}=+*#01█▓▒@$%';
function GlitchText({ text }) {
  const [out, setOut] = React.useState(text);
  const timer = React.useRef();
  const run = React.useCallback(() => {
    let frame = 0;
    const total = 20;
    clearInterval(timer.current);
    timer.current = setInterval(() => {
      frame += 1;
      const revealed = Math.floor((frame / total) * text.length);
      let s = '';
      for (let i = 0; i < text.length; i++) {
        if (text[i] === ' ') s += ' ';
        else if (i < revealed) s += text[i];
        else s += GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      setOut(s);
      if (frame >= total) { setOut(text); clearInterval(timer.current); }
    }, 32);
  }, [text]);
  React.useEffect(() => { run(); return () => clearInterval(timer.current); }, [run]);
  return (
    <span className="ic-glitch" style={{ cursor: 'crosshair', whiteSpace: 'nowrap' }} onMouseEnter={run} title={text}>
      {out}
    </span>
  );
}

function InternetHome() {
  const { paidTotal, epochs, asset } = useLedger();
  const paidLine = `${fmtAmt(paidTotal)} ${asset} paid to holders so far across ${epochs.length} epoch${epochs.length === 1 ? '' : 's'}`;
  return (
    <Page className="web--lime">
      <div className="ic-marquee">
        <div className="ic-marquee__inner">
          ★ WELCOME TO THE INTERNET ★ INTERNET COIN — the internet pays
          dividends now ★ holders receive real tokenized internet stocks ★
          MSFT · paid in real Microsoft ★ THE MISSION: onboard the internet — 1% = 55,000,000 frens ★ 2% per trade, 1.7% to holders ★ {epochs.length > 0 ? `${paidLine} ★ ` : ''}CA: 0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c — anything claiming otherwise is fake ★
          est. 2025 ★
        </div>
      </div>

      <table className="ic-frame" cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td className="ic-hero">
              <img className="ic-e" src={pfp} alt="Internet Coin" />
              <h1><GlitchText text="INTERNET COIN" /></h1>
              <div className="ic-tagline">The Internet pays dividends now.</div>
              <div className="ic-bio">coin on the internet. (real)</div>
              <div className="ic-sub">
                A memecoin launching on pons V2 on Robinhood Chain. Traders pay
                2% per trade (1% creator tax + pons&apos; 1% base fee), and 1.7% of
                every trade is airdropped to holders as real tokenized Microsoft (MSFT) — by
                pons, automatically. That&apos;s it. That&apos;s the coin.
              </div>
              <div className="ic-badges">
                <Badge>BEST VIEWED IN 800×600</Badge>
                <Badge>NOW WITH DIVIDENDS</Badge>
                <Badge>CA: 0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c</Badge>
              </div>
            </td>
          </tr>

          <tr>
            <td className="ic-section ic-new">
              <h2>▸ NEW ON THE DESKTOP <span className="ic-new-tag">you asked → we shipped</span></h2>
              <p className="ic-quote">&quot;more games… old movies… a browser where the websites show old… a terminal with python&quot; — the lobby, this week</p>
              <div className="ic-new-grid">
                {CASINO_LIVE || CASINO_PRACTICE ? (
                  <button type="button" className="ic-new-btn ic-new-btn--casino" onClick={() => openApp('Casino')}>
                    <b>CASINO.exe{CASINO_PRACTICE ? ' · practice' : ''}</b>
                    <span>
                      {CASINO_PRACTICE
                        ? 'Four cabinets — The Blue Screen, Minesweeper: Hard Mode, Dial-Up, Coinflip — on play money. Same odds as the real floor, decided by the drand beacon in your browser, nothing on chain.'
                        : 'Four cabinets — The Blue Screen, Minesweeper: Hard Mode, Dial-Up, Coinflip — settled against the drand beacon, on chain, in tokenized MSFT.'}
                    </span>
                  </button>
                ) : null}
                <button type="button" className="ic-new-btn" onClick={() => openApp('Games')}>
                  <b>Games</b>
                  <span>40 real classics — SkiFree, DOOM, Prince of Persia, Oregon Trail, SimCity — emulated in your browser by the Internet Archive.</span>
                </button>
                <button type="button" className="ic-new-btn" onClick={() => openApp('Windows Media Player')}>
                  <b>Old Movies</b>
                  <span>32 public-domain films in Windows Media Player. Night of the Living Dead. Nosferatu. Plan 9. Movie night, on the internet.</span>
                </button>
                <button type="button" className="ic-new-btn" onClick={() => openApp('Time Machine')}>
                  <b>Time Machine</b>
                  <span>Internet Explorer&apos;s address bar works now — through the Wayback Machine. Google 2003. MySpace 2006. Pick the year.</span>
                </button>
                <button type="button" className="ic-new-btn" onClick={() => openApp('My Pictures')}>
                  <b>My Pictures</b>
                  <span>Every meme, poster, wallpaper and logo we&apos;ve made, in one folder. Save any of it. Set one as your desktop background.</span>
                </button>
                <button type="button" className="ic-new-btn" onClick={() => openApp('Command Prompt')}>
                  <b>Command Prompt</b>
                  <span>cmd.exe with real commands, live chain reads, and PYTHON — an actual Python 3.12 shell. Java not included. (real)</span>
                </button>
              </div>
            </td>
          </tr>

          <InternetCore />

          <tr>
            <td className="ic-section">
              <h2>▸ THE STORY</h2>
              <p className="ic-quote">&quot;remember how the internet used to feel, fren?&quot;</p>
              <p>
                Internet Coin is a memecoin about the Internet — the old one.
                Dial-up. Desktops. A web that belonged to the people on it.
                Pure Y2K nostalgia, with nowhere for the vibes to go. Until
                now.
              </p>
              <p className="ic-quote">
                &quot;The first Internet was free... but every cent it
                generated flowed to a handful of corporations.&quot;
                <span className="ic-quote-src"> — the original mission, 2025</span>
              </p>
              <p>
                Robinhood Chain put the Internet&apos;s actual stocks on-chain,
                trading 24/7 as tokens. So the Internet is back — and this time
                the little guy owns a piece of the network he helped create.
                Literally. In his wallet. Some of you were here the first time.
                You know.
              </p>
            </td>
          </tr>

          <tr>
            <td className="ic-section">
              <h2>▸ THE MISSION</h2>
              <p className="ic-quote">&quot;what if we could onboard all of the internet?&quot;</p>
              <p>
                Every cult coin has a mission. Ours fits in three words:
                <b> onboard the internet.</b> 5,500,000,000 people are online.
                Milestone 1 is one in a hundred of them — <b>55,000,000 frens</b>
                holding the internet. Then the rest.
              </p>
              <p className="ic-fine">
                A headcount goal, never a price goal. Progress lives in MISSION.exe
                on the desktop and reads from the chain after launch.
              </p>
            </td>
          </tr>

          <tr>
            <td className="ic-section">
              <h2>▸ HOW IT WORKS</h2>
              <ol className="ic-steps">
                <li>
                  1% creator tax + pons&apos; 1% base fee = 2% per trade, fixed
                  at creation — it can never be raised. 1.7% of every trade goes
                  to holders, 0.3% to pons. The dev earns nothing from trading.
                </li>
                <li>
                  No buying step needed: the coin trades against MSFT, so the
                  fee arrives already AS real tokenized Microsoft stock.
                </li>
                <li>
                  pons&apos; distributor splits it pro-rata and pons&apos; keeper
                  airdrops it to every holder, around the clock. No claiming.
                  No dev wallet in the loop. Every transaction public.
                </li>
              </ol>
              <p className="ic-fine">
                Payouts depend entirely on trading activity. Nothing here is a
                promise, a yield, or financial advice. It&apos;s the Internet.
              </p>
            </td>
          </tr>

          <tr>
            <td className="ic-section">
              <h2>▸ PAYDAY, AROUND THE CLOCK</h2>
              <p>
                No Friday. No claiming. Every epoch pons publishes the split and
                airdrops the MSFT; the wallets get heavier and the sound plays:
                <b> &quot;You&apos;ve got dividends.&quot;</b>
              </p>
              <p className="ic-fine">
                {epochs.length > 0
                  ? `${paidLine} — read live from the chain. Receipts in DIVIDENDS.exe. Your own number, on a pay stub, in PAYDAY.exe.`
                  : 'First epoch lands after launch, once real fees exist. Watch DIVIDENDS.exe and PAYDAY.exe on the desktop.'}
              </p>
            </td>
          </tr>

          <tr>
            <td className="ic-footer">
              <div className="ic-counter">
                You are visitor <span>0088888</span>
              </div>
              <div className="ic-webring">
                (っ◔◡◔)っ ♥ the internet always stays ONLINE ♥
              </div>
              <div className="ic-copy">
                Parody. Not affiliated with, endorsed by, or sponsored by Microsoft
                Corporation. MSFT on this site means a third-party tokenized product.
              </div>
              <div className="ic-copy">
                © 2025-2026 the Internet · not affiliated with anyone · CA: 0x88888cC1c17FfcBa563F418c61596b3fa2Ca2e2c
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Page>
  );
}

const Page = styled.div`
  ${xpCss}
  ${webCss}
  position: absolute;
  inset: 0;
  overflow: auto;
  background: ${WEB.paper};
  color: ${WEB.ink};
  font-family: 'Trebuchet MS', Tahoma, sans-serif;

  .ic-marquee {
    overflow: hidden;
    border-bottom: 1px solid ${WEB.goldDeep};
    background: ${XP.lime};
    white-space: nowrap;
  }
  .ic-marquee__inner {
    display: inline-block;
    padding: 4px 0;
    font-size: 12px;
    animation: ic-scroll 28s linear infinite;
  }
  @keyframes ic-scroll {
    from {
      transform: translateX(35%);
    }
    to {
      transform: translateX(-100%);
    }
  }

  .ic-frame {
    width: 96%;
    margin: 14px auto;
    border: 2px ridge ${WEB.goldDeep};
    background: ${WEB.cream};
  }
  .ic-hero {
    text-align: center;
    padding: 26px 20px 18px;
    border-bottom: 1px dashed ${WEB.goldDeep};
  }
  .ic-e {
    width: 150px;
    height: 150px;
    filter: drop-shadow(0 0 18px rgba(204, 255, 0, 0.75))
      drop-shadow(0 0 55px rgba(204, 255, 0, 0.35));
    animation: ic-pulse 3.2s ease-in-out infinite;
  }
  @keyframes ic-pulse {
    0%,
    100% {
      filter: drop-shadow(0 0 14px rgba(204, 255, 0, 0.65))
        drop-shadow(0 0 45px rgba(204, 255, 0, 0.28));
    }
    50% {
      filter: drop-shadow(0 0 26px rgba(204, 255, 0, 0.9))
        drop-shadow(0 0 70px rgba(204, 255, 0, 0.45));
    }
  }
  h1 {
    margin: 10px 0 2px;
    font-size: 34px;
    letter-spacing: 4px;
    color: ${WEB.ink};
    text-shadow: none;
  }
  .ic-tagline {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
  }
  .ic-bio {
    font-size: 11px;
    color: ${WEB.brown};
    margin-bottom: 10px;
  }
  .ic-quote {
    font-style: italic;
    color: ${WEB.ink} !important;
  }
  .ic-quote-src {
    font-style: normal;
    font-size: 10px;
    color: ${WEB.brown};
  }
  .ic-sub {
    max-width: 520px;
    margin: 0 auto;
    font-size: 12px;
    color: ${WEB.ink};
    line-height: 1.5;
  }
  .ic-badges {
    margin-top: 14px;
  }
  .ic-badge {
    display: inline-block;
    border: 1px solid ${WEB.goldDeep};
    padding: 2px 8px;
    margin: 0 4px;
    font-size: 10px;
    letter-spacing: 1px;
    background: ${XP.lime};
  }
  .ic-new {
    background: linear-gradient(90deg, rgba(204, 255, 0, 0.08), transparent);
    border-top: 1px solid ${WEB.goldDeep};
  }
  .ic-new-tag {
    display: inline-block;
    margin-left: 10px;
    padding: 1px 8px;
    background: ${XP.lime};
    color: #000;
    font-size: 10px;
    letter-spacing: 1px;
    vertical-align: middle;
  }
  .ic-new-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 8px;
    margin-top: 6px;
  }
  .ic-new-btn--casino {
    border-color: ${WEB.ink} !important;
    background: ${WEB.cream} !important;
    color: ${WEB.ink} !important;
  }
  .ic-new-btn--casino b {
    color: ${WEB.ink} !important;
  }
  .ic-new-btn {
    text-align: left;
    background: ${WEB.cream};
    border: 1px solid ${WEB.goldDeep};
    color: ${WEB.ink};
    padding: 8px 10px;
    font: inherit;
    font-size: 11px;
    line-height: 1.45;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 2px;
    b {
      color: ${WEB.ink};
      font-size: 13px;
    }
    &:hover {
      border-color: ${WEB.ink};
      box-shadow: 0 0 12px rgba(204, 255, 0, 0.35);
      background: ${WEB.cream};
    }
  }
  .ic-core {
    background: linear-gradient(90deg, rgba(204, 255, 0, 0.05), transparent);
  }
  .ic-core-strip {
    display: flex;
    gap: 6px;
    overflow: hidden;
    margin-top: 6px;
  }
  .ic-core-thumb {
    height: 96px;
    width: auto;
    flex-shrink: 0;
    display: block;
    border: 1px solid ${WEB.goldDeep};
    cursor: pointer;
    &:hover {
      border-color: ${WEB.ink};
      box-shadow: 0 0 12px rgba(204, 255, 0, 0.35);
    }
  }
  .ic-core-open {
    margin-top: 8px;
    span {
      color: ${WEB.ink};
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .ic-section {
    padding: 14px 26px;
    border-bottom: 1px dashed ${WEB.goldDeep};
    h2 {
      font-size: 14px;
      letter-spacing: 2px;
      color: ${WEB.ink};
      margin-bottom: 6px;
    }
    p {
      font-size: 12px;
      line-height: 1.55;
      color: ${WEB.ink};
      margin-bottom: 8px;
    }
  }
  .ic-steps {
    margin: 4px 0 8px 22px;
    font-size: 12px;
    color: ${WEB.ink};
    li {
      margin-bottom: 4px;
    }
  }
  .ic-fine {
    font-size: 10px;
    color: ${WEB.brown};
  }
  .ic-footer {
    text-align: center;
    padding: 14px;
    font-size: 11px;
    color: ${WEB.brown};
  }
  .ic-counter span {
    font-family: 'Courier New', monospace;
    background: ${XP.lime};
    border: 1px solid ${WEB.goldDeep};
    color: ${WEB.ink};
    padding: 1px 5px;
    letter-spacing: 2px;
  }
  .ic-webring {
    margin: 8px 0 4px;
  }
`;

export default InternetHome;
